
import React from "react";
import SiteDetailPage from "@/components/sites/SiteDetailPage";

const FabrudeRecyclage = () => {
  const services = [
    "Recyclage de déchets industriels",
    "Traitement de métaux",
    "Collecte spécialisée",
    "Valorisation énergétique"
  ];

  return (
    <SiteDetailPage
      title="Fabrude Recyclage - Traitement Déchets Industriels Saint-Paul-des-Landes (15250)"
      description="Fabrude Recyclage à Saint-Paul-des-Landes - Centre moderne de traitement et valorisation des déchets industriels dans le Cantal. Solutions innovantes."
      proximityInfo="Installation de recyclage de pointe située dans le Cantal, offrant des solutions innovantes pour le traitement des déchets industriels et métalliques."
      address="Prentegarde"
      postalCode="15250"
      city="Saint-Paul-des-Landes"
      phone="05.63.54.78.90"
      email="contactgfe@groupefabre.com"
      website="https://fabrude-recyclage.fr/"
      services={services}
      coordinates={{ lat: 44.9770, lng: 2.2400 }}
      isMiniSite={true}
    />
  );
};

export default FabrudeRecyclage;
